function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcheckSimple2 = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3602 3.51078L8.4302 13.4408L5.6402 10.6508C4.8602 9.87078 3.5902 9.87078 2.8102 10.6508L1.4102 12.0508C0.630195 12.8308 0.630195 14.1008 1.4102 14.8808L7.0102 20.4808C7.7902 21.2608 9.0602 21.2608 9.8402 20.4808L22.5902 7.74078C23.3702 6.96078 23.3702 5.69078 22.5902 4.91078L21.1902 3.51078C20.4002 2.73078 19.1402 2.73078 18.3602 3.51078ZM20.4698 5.63088C20.8598 6.02088 20.8598 6.64088 20.4698 7.03088L9.1298 18.3709C8.7398 18.7609 8.1198 18.7609 7.7298 18.3709L3.5298 14.1709C3.1398 13.7809 3.1398 13.1609 3.5298 12.7709C3.9198 12.3809 4.5398 12.3809 4.9298 12.7709L8.4298 16.2709L19.0698 5.63088C19.4598 5.24088 20.0798 5.24088 20.4698 5.63088Z",
    fill: "#495057"
  }));
});